import { getAxiosInstance } from "../http";

import { Area } from "../models";

export class AreaService {

    static getAreaList = async (apiPrefix: string): Promise<Area[]> => {

        const instance = getAxiosInstance()

        const response = await instance.get(apiPrefix + '/areas')

        return response.data.map((a: any) => Area.fromJSON(a))
    }

    static createArea = async (area: Area, apiPrefix: string): Promise<Area> => {

        const instance = getAxiosInstance()

        const response = await instance.post(apiPrefix + '/areas', JSON.stringify(area))

        return Area.fromJSON(response.data)
    }
}